export default function TaskAssignee({itemData, classes}) {
    return <>
        {itemData.assignee_users && itemData.assignee_users.length > 0 && <div className='flex-container'>
            {itemData.assignee_resolved ? <span className={classes.task_resolved}>
                <i className="ti ti-user"></i>
            </span> 
            :
            <span className={classes.task_not_resolved}>
                <i className="ti ti-user"></i>
            </span>}
            <div>
                {itemData.assignee_users.map(item => (
                    <div key={item.id}>{item.name}</div>
                ))}
            </div>
        </div>}

        {itemData.assignee_teams && itemData.assignee_teams.length > 0 && <div className='flex-container'>
            {itemData.assignee_resolved ? <span className={classes.task_resolved}>
                <i className="ti ti-users-group"></i>
            </span> 
            :
            <span className={classes.task_not_resolved}>
                <i className="ti ti-users-group"></i>
            </span>}
            <div>
                {itemData.assignee_teams.map(item => (
                    <div key={item.id}>{item.name}</div>
                ))}
            </div>
        </div>}
    </>
}